/**
 * @deprecated Use `src/shared/config/physics.config.ts` directly
 * (`import { PHYSICS } from '<path>/shared/config/physics.config'`).
 *
 * This file is now a backwards-compat shim that maps the new typed,
 * camelCase config to the legacy ALL_CAPS shape consumers expect.
 * Migrate per-file at your leisure; remove this shim once all consumers
 * have moved.
 *
 * The migrated config follows the defaults+dev-override pattern documented
 * in `docs/plans/2026-04-25-CONFIG-MIGRATION.md`.
 */

import { PHYSICS } from '../config/physics.config';

export const PHYSICS_CONFIG = {
  GRAVITY: {
    DEFAULT: PHYSICS.gravity.default,
    FALLING_MULTIPLIER: PHYSICS.gravity.fallingMultiplier,
    TERMINAL_VELOCITY: PHYSICS.gravity.terminalVelocity,
    AIR_FRICTION: PHYSICS.gravity.airFriction,
    MAX_FALL_SPEED: PHYSICS.gravity.maxFallSpeed,
    NPC_GRAVITY: PHYSICS.gravity.npcGravity,
  },
  FRICTION: {
    AIR: PHYSICS.friction.air,
    GROUND_DECEL: PHYSICS.friction.groundDecel,
    NPC_DRAG: PHYSICS.friction.npcDrag,
  },
  MOVEMENT: {
    COYOTE_TIME: PHYSICS.movement.coyoteTimeMs,
    JUMP_BUFFER: PHYSICS.movement.jumpBufferMs,
    CORNER_NUDGE: PHYSICS.movement.cornerNudgePx,
  },
  LOGIC: {
    GROUND_SNAP_OFFSET_Y: PHYSICS.logic.groundSnapOffsetY,
    GROUND_SNAP_BUFFER: PHYSICS.logic.groundSnapBuffer,
    MAX_PLATFORM_SEARCH_DISTANCE: PHYSICS.logic.maxPlatformSearchDistance,
    PLATFORM_CHECK_INTERVAL: PHYSICS.logic.platformCheckIntervalMs,
  },
  SIMULATION: {
    FIXED_DT: PHYSICS.simulation.fixedDt,
    MAX_ACCUMULATOR: PHYSICS.simulation.maxAccumulator,
  },
};
